import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'

// 
export default {
  getList(params) { // 获取活动列表
    const url =  baseURL + '/TbActivity/getList';
    return axios.post(url, qs.stringify(params));
  },
  getUserIntegral(params) { // 获取用户积分数据
    const url =  baseURL + '/TbActivity/getUserIntegral';
    return axios.post(url, qs.stringify(params));
  },
  exchange(params) { // 兑换
    const url =  baseURL + '/TbActivity/exchange';
    return axios.post(url, qs.stringify(params));
  },
  tbCreditsExchangeGetList(params) { // 兑换记录
    const url =  baseURL + '/tbCreditsExchange/getList';
    return axios.post(url, qs.stringify(params));
  },
  
  
  
}


// WEBPACK FOOTER //
// ./src/api/integral.js